/* Mazda add-on data for Al Ubaid Motors YOM Finder. Load after aum-yom-data.js and all existing add-on files. */
(function(){
  window.AUM_VEHICLE_IMAGES = window.AUM_VEHICLE_IMAGES || {};
  window.AUM_YOM_DATABASE = window.AUM_YOM_DATABASE || [];

  var imgs = `6|https://cdn.shopify.com/s/files/1/0670/1655/6705/files/MAZDA_6.jpg?v=1784733059
BONGO|https://cdn.shopify.com/s/files/1/0670/1655/6705/files/MAZDA_BONGO.jpg?v=1784733111
BONGO BRAWNY VAN|https://cdn.shopify.com/s/files/1/0670/1655/6705/files/MAZDA_BONGO_BRAWNY_VAN.jpg?v=1784733466
BONGO VAN|https://cdn.shopify.com/s/files/1/0670/1655/6705/files/MAZDA_BONGO_VAN.jpg?v=1784733481
CAROL|https://cdn.shopify.com/s/files/1/0670/1655/6705/files/MAZDA_CAROL.jpg?v=1784733377
CX-3|https://cdn.shopify.com/s/files/1/0670/1655/6705/files/MAZDA_CX-3.jpg?v=1784733453
CX-30|https://cdn.shopify.com/s/files/1/0670/1655/6705/files/MAZDA_CX-30.jpg?v=1784733533
CX-5|https://cdn.shopify.com/s/files/1/0670/1655/6705/files/MAZDA_CX-5.jpg?v=1784733615
CX-60|https://cdn.shopify.com/s/files/1/0670/1655/6705/files/MAZDA_CX-60.jpg?v=1784733658
CX-8|https://cdn.shopify.com/s/files/1/0670/1655/6705/files/MAZDA_CX-8.jpg?v=1784733709
FAMILIA VAN|https://cdn.shopify.com/s/files/1/0670/1655/6705/files/MAZDA_FAMILIA_VAN.jpg?v=1784733752
FLAIR|https://cdn.shopify.com/s/files/1/0670/1655/6705/files/MAZDA_FLAIR.jpg?v=1784733806
FLAIR CROSSOVER|https://cdn.shopify.com/s/files/1/0670/1655/6705/files/MAZDA_FLAIR_CROSSOVER.jpg?v=1784733859
FLAIR WAGON|https://cdn.shopify.com/s/files/1/0670/1655/6705/files/MAZDA_FLAIR_WAGON.jpg?v=1784733918
MAZDA2|https://cdn.shopify.com/s/files/1/0670/1655/6705/files/MAZDA_MAZDA2.jpg?v=1784733960
MAZDA3|https://cdn.shopify.com/s/files/1/0670/1655/6705/files/MAZDA_MAZDA3.jpg?v=1784733986
MX-30|https://cdn.shopify.com/s/files/1/0670/1655/6705/files/MAZDA_MX-30.jpg?v=1784734040
ROADSTER|https://cdn.shopify.com/s/files/1/0670/1655/6705/files/MAZDA_ROADSTER.jpg?v=1784734087
SCRUM|https://cdn.shopify.com/s/files/1/0670/1655/6705/files/MAZDA_SCRUM.jpg?v=1784734150
SCRUM TRUCK|https://cdn.shopify.com/s/files/1/0670/1655/6705/files/MAZDA_SCRUM_TRUCK.jpg?v=1784734190
TITAN|https://cdn.shopify.com/s/files/1/0670/1655/6705/files/MAZDA_TITAN.jpg?v=1784734226`;

  imgs.trim().split(/\n/).forEach(function(line){
    var p = line.split('|');
    if (p.length >= 2) window.AUM_VEHICLE_IMAGES['MAZDA|' + p[0].trim().toUpperCase()] = p.slice(1).join('|').trim();
  });

  var rows = `MAZDA	6	2020	GJ2FP-500451	GJ2FP-550133
MAZDA	6	2021	GJ2FP-550134	GJ2FP-550482
MAZDA	6	2022	GJ2FP-550484	GJ2FP-600136
MAZDA	6	2023	GJ2FP-600137	GJ2FP-600598
MAZDA	6	2020	GJ2FW-500483	GJ2FW-550127
MAZDA	6	2021	GJ2FW-550128	GJ2FW-550492
MAZDA	6	2022	GJ2FW-550493	GJ2FW-600076
MAZDA	6	2023	GJ2FW-600077	GJ2FW-600392
MAZDA	6	2020	GJEFP-500241	GJEFP-550133
MAZDA	6	2021	GJEFP-550134	GJEFP-550567
MAZDA	6	2022	GJEFP-550568	GJEFP-600010
MAZDA	6	2023	GJEFP-600011	GJEFP-600262
MAZDA	6	2020	GJEFW-500198	GJEFW-550094
MAZDA	6	2021	GJEFW-550095	GJEFW-550400
MAZDA	6	2022	GJEFW-550401	GJEFW-600002
MAZDA	BONGO	2021	S403F-7000683	S403F-7001099
MAZDA	BONGO	2022	S403F-7001100	S403F-7002010
MAZDA	BONGO	2023	S403F-7002011	S403F-7002806
MAZDA	BONGO	2020	SLP2T-118700	SLP2T-121836
MAZDA	BONGO BRAWNY VAN	2022	GDH201-2900059	GDH201-2900154
MAZDA	BONGO BRAWNY VAN	2023	GDH201-2900155	GDH201-2900298
MAZDA	BONGO BRAWNY VAN	2024	GDH201-2900299	GDH201-2900360
MAZDA	BONGO BRAWNY VAN	2025	GDH201-2900361	GDH201-2900481
MAZDA	BONGO BRAWNY VAN	2020	GDH206-2900216	GDH206-2900457
MAZDA	BONGO BRAWNY VAN	2021	GDH206-2900458	GDH206-2900627
MAZDA	BONGO BRAWNY VAN	2022	GDH206-2900628	GDH206-2900785
MAZDA	BONGO BRAWNY VAN	2020	TRH200-9000350	TRH200-9000813
MAZDA	BONGO BRAWNY VAN	2021	TRH200-9000814	TRH200-9000998
MAZDA	BONGO BRAWNY VAN	2022	TRH200-9000999	TRH200-9001399
MAZDA	BONGO VAN	2020	S403Z-7000051	S403Z-7000577
MAZDA	BONGO VAN	2021	S403Z-7000578	S403Z-7000978
MAZDA	BONGO VAN	2022	S403Z-7000979	S403Z-7001585
MAZDA	BONGO VAN	2023	S403Z-7001586	S403Z-7002328
MAZDA	BONGO VAN	2024	S403Z-7002329	S403Z-7002660
MAZDA	BONGO VAN	2025	S403Z-7002661	S403Z-7002995
MAZDA	BONGO VAN	2020	S413Z-7000051	S413Z-7000322
MAZDA	BONGO VAN	2021	S413Z-7000323	S413Z-7000510
MAZDA	BONGO VAN	2022	S413Z-7000511	S413Z-7000842
MAZDA	BONGO VAN	2023	S413Z-7000843	S413Z-7001164
MAZDA	BONGO VAN	2020	SLP2V-112408	SLP2V-114471
MAZDA	BONGO VAN	2020	SLP2M-105855	SLP2M-106383
MAZDA	CAROL	2022	HB37S-100008	HB37S-101944
MAZDA	CAROL	2023	HB37S-101945	HB37S-160192
MAZDA	CAROL	2024	HB37S-160193	HB37S-162582
MAZDA	CAROL	2025	HB37S-162583	HB37S-211524
MAZDA	CAROL	2022	HB97S-100010	HB97S-101677
MAZDA	CAROL	2023	HB97S-101678	HB97S-160134
MAZDA	CAROL	2024	HB97S-160135	HB97S-161752
MAZDA	CAROL	2025	HB97S-161753	HB97S-210911
MAZDA	CAROL	2020	HB36S-235126	HB36S-601080
MAZDA	CAROL	2021	HB36S-601081	HB36S-603916
MAZDA	CX-3	2022	DK8FY-500201	DK8FY-500569
MAZDA	CX-3	2022	DK8FY-500570	DK8FY-501109
MAZDA	CX-3	2025	DK8FY-861039	DK8FY-861870
MAZDA	CX-3	2022	DKLFY-500201	DKLFY-502785
MAZDA	CX-3	2023	DKLFY-502786	DKLFY-507253
MAZDA	CX-3	2025	DKLFY-846178	DKLFY-851561
MAZDA	CX-3	2023	DK8AY-500377	DK8AY-500828
MAZDA	CX-3	2020	DK8AW-200001	DK8AW-200240
MAZDA	CX-3	2021	DK8AW-200241	DK8AW-200455
MAZDA	CX-3	2020	DK8FW-200002	DK8FW-200483
MAZDA	CX-3	2021	DK8FW-200484	DK8FW-250291
MAZDA	CX-3	2022	DK8FW-250292	DK8FW-250798
MAZDA	CX-3	2020	DKLAW-100002	DKLAW-100890
MAZDA	CX-3	2021	DKLAW-100891	DKLAW-150335
MAZDA	CX-3	2022	DKLAW-150336	DKLAW-151001
MAZDA	CX-3	2020	DKLFW-100002	DKLFW-104626
MAZDA	CX-3	2021	DKLFW-104627	DKLFW-151740
MAZDA	CX-3	2022	DKLFW-151741	DKLFW-155121
MAZDA	CX-30	2023	DMEJ3R-100003	DMEJ3R-103903
MAZDA	CX-30	2025	DMEJ3R-155835	DMEJ3R-162252
MAZDA	CX-30	2023	DM8R-100001	DM8R-102181
MAZDA	CX-30	2025	DM8R-200002	DM8R-201060
MAZDA	CX-30	2022	DMEJ3P-100006	DMEJ3P-104275
MAZDA	CX-30	2023	DMEJ3P-104276	DMEJ3P-112959
MAZDA	CX-30	2020	DM8P-104157	DM8P-112162
MAZDA	CX-30	2021	DM8P-112163	DM8P-201401
MAZDA	CX-30	2022	DM8P-201402	DM8P-206471
MAZDA	CX-30	2023	DM8P-206472	DM8P-209955
MAZDA	CX-30	2020	DMEP-105853	DMEP-123922
MAZDA	CX-30	2021	DMEP-123923	DMEP-202968
MAZDA	CX-30	2022	DMEP-202969	DMEP-209623
MAZDA	CX-5	2020	KF2P-400529	KF2P-452807
MAZDA	CX-5	2021	KF2P-452808	KF2P-502947
MAZDA	CX-5	2022	KF2P-502948	KF2P-552267
MAZDA	CX-5	2023	KF2P-552268	KF2P-605588
MAZDA	CX-5	2025	KF2P-614991	KF2P-628285
MAZDA	CX-5	2020	KFEP-400161	KFEP-404905
MAZDA	CX-5	2021	KFEP-500004	KFEP-501504
MAZDA	CX-5	2022	KFEP-501505	KFEP-551107
MAZDA	CX-5	2023	KFEP-551108	KFEP-602494
MAZDA	CX-5	2025	KFEP-610197	KFEP-619218
MAZDA	CX-5	2020	KF5P-400145	KF5P-450649
MAZDA	CX-5	2021	KF5P-450650	KF5P-500633
MAZDA	CX-5	2022	KF5P-500634	KF5P-550613
MAZDA	CX-5	2023	KF5P-550614	KF5P-600738
MAZDA	CX-5	2025	KF5P-603031	KF5P-604792
MAZDA	CX-60	2023	KH3P-100015	KH3P-111699
MAZDA	CX-60	2025	KH3P-200005	KH3P-205638
MAZDA	CX-60	2023	KH5P-100009	KH5P-105318
MAZDA	CX-60	2025	KH5P-200003	KH5P-202337
MAZDA	CX-60	2022	KH3R3P-100013	KH3R3P-107953
MAZDA	CX-60	2023	KH3R3P-107954	KH3R3P-112682
MAZDA	CX-60	2025	KH3R3P-200006	KH3R3P-203427
MAZDA	CX-60	2022	KH5S3P-100004	KH5S3P-100547
MAZDA	CX-60	2023	KH5S3P-100548	KH5S3P-101200
MAZDA	CX-60	2025	KH5S3P-200003	KH5S3P-200149
MAZDA	CX-8	2020	KG2P-301944	KG2P-351218
MAZDA	CX-8	2021	KG2P-351219	KG2P-361601
MAZDA	CX-8	2022	KG2P-361602	KG2P-451326
MAZDA	CX-8	2023	KG2P-451327	KG2P-462307
MAZDA	CX-8	2020	KG5P-201176	KG5P-250975
MAZDA	CX-8	2021	KG5P-250976	KG5P-256558
MAZDA	CX-8	2022	KG5P-256559	KG5P-350722
MAZDA	CX-8	2023	KG5P-350723	KG5P-356558
MAZDA	FAMILIA VAN	2020	NCP165-7000531	NCP165-7000884
MAZDA	FAMILIA VAN	2021	NCP165-7000885	NCP165-7001129
MAZDA	FAMILIA VAN	2022	NCP165-7001130	NCP165-7001464
MAZDA	FAMILIA VAN	2023	NCP165-7001465	NCP165-7001808
MAZDA	FAMILIA VAN	2024	NCP165-7001809	NCP165-7002169
MAZDA	FAMILIA VAN	2025	NCP165-7002170	NCP165-7002492
MAZDA	FAMILIA VAN	2020	NCP160-7002106	NCP160-7003416
MAZDA	FAMILIA VAN	2021	NCP160-7003417	NCP160-7004184
MAZDA	FAMILIA VAN	2022	NCP160-7004185	NCP160-7005024
MAZDA	FAMILIA VAN	2023	NCP160-7005025	NCP160-7005753
MAZDA	FLAIR	2020	MJ95S-100031	MJ95S-105803
MAZDA	FLAIR	2021	MJ95S-105804	MJ95S-110083
MAZDA	FLAIR	2022	MJ95S-110084	MJ95S-121605
MAZDA	FLAIR	2023	MJ95S-121606	MJ95S-130994
MAZDA	FLAIR	2024	MJ95S-130995	MJ95S-134003
MAZDA	FLAIR	2025	MJ95S-134004	MJ95S-136664
MAZDA	FLAIR CROSSOVER	2020	MS52S-100002	MS52S-101314
MAZDA	FLAIR CROSSOVER	2021	MS52S-101315	MS52S-102485
MAZDA	FLAIR CROSSOVER	2022	MS52S-102486	MS52S-102980
MAZDA	FLAIR CROSSOVER	2022	MS92S-300001	MS92S-302706
MAZDA	FLAIR CROSSOVER	2023	MS92S-302707	MS92S-307842
MAZDA	FLAIR CROSSOVER	2024	MS92S-307843	MS92S-309706
MAZDA	FLAIR WAGON	2024	MM94S-101293	MM94S-113134
MAZDA	FLAIR WAGON	2025	MM94S-113135	MM94S-123963
MAZDA	FLAIR WAGON	2024	MM54S-100243	MM54S-103916
MAZDA	FLAIR WAGON	2025	MM54S-103917	MM54S-107730
MAZDA	FLAIR WAGON	2020	MM53S-710001	MM53S-711877
MAZDA	FLAIR WAGON	2021	MM53S-711878	MM53S-730273
MAZDA	FLAIR WAGON	2022	MM53S-730274	MM53S-733496
MAZDA	FLAIR WAGON	2023	MM53S-733497	MM53S-736862
MAZDA	MAZDA2	2020	DJLFS-708500	DJLFS-729779
MAZDA	MAZDA2	2021	DJLFS-729780	DJLFS-739571
MAZDA	MAZDA2	2022	DJLFS-739572	DJLFS-776939
MAZDA	MAZDA2	2023	DJLFS-776940	DJLFS-850919
MAZDA	MAZDA2	2025	DJLFS-863168	DJLFS-877270
MAZDA	MAZDA2	2020	DJ5FS-602005	DJ5FS-605302
MAZDA	MAZDA2	2021	DJ5FS-605303	DJ5FS-651254
MAZDA	MAZDA2	2022	DJ5FS-651255	DJ5FS-653728
MAZDA	MAZDA2	2023	DJ5FS-653729	DJ5FS-702065
MAZDA	MAZDA2	2020	DJLAS-201507	DJLAS-204309
MAZDA	MAZDA2	2021	DJLAS-204310	DJLAS-251227
MAZDA	MAZDA2	2022	DJLAS-251228	DJLAS-253848
MAZDA	MAZDA2	2023	DJLAS-253849	DJLAS-301707
MAZDA	MAZDA2	2025	DJLAS-302320	DJLAS-303079
MAZDA	MAZDA2	2020	DJ5AS-600559	DJ5AS-601261
MAZDA	MAZDA2	2021	DJ5AS-601262	DJ5AS-650289
MAZDA	MAZDA2	2022	DJ5AS-650290	DJ5AS-650809
MAZDA	MAZDA2	2023	DJ5AS-650810	DJ5AS-700471
MAZDA	MAZDA3	2023	BPFJ3R-100002	BPFJ3R-104534
MAZDA	MAZDA3	2025	BPFJ3R-200001	BPFJ3R-201027
MAZDA	MAZDA3	2023	BP5R-100001	BP5R-102340
MAZDA	MAZDA3	2025	BP5R-200001	BP5R-200430
MAZDA	MAZDA3	2023	BP8R-100002	BP8R-101777
MAZDA	MAZDA3	2025	BP8R-200001	BP8R-200555
MAZDA	MAZDA3	2022	BPFJ3P-100004	BPFJ3P-102676
MAZDA	MAZDA3	2023	BPFJ3P-102677	BPFJ3P-104337
MAZDA	MAZDA3	2020	BP5P-108332	BP5P-115778
MAZDA	MAZDA3	2021	BP5P-115779	BP5P-201497
MAZDA	MAZDA3	2022	BP5P-201498	BP5P-207276
MAZDA	MAZDA3	2023	BP5P-207277	BP5P-209636
MAZDA	MAZDA3	2020	BP8P-107442	BP8P-110830
MAZDA	MAZDA3	2021	BP8P-110831	BP8P-200578
MAZDA	MAZDA3	2022	BP8P-200579	BP8P-202897
MAZDA	MAZDA3	2023	BP8P-202898	BP8P-203754
MAZDA	MAZDA3	2020	BPEP-101263	BPEP-102668
MAZDA	MAZDA3	2021	BPEP-102669	BPEP-200249
MAZDA	MAZDA3	2022	BPEP-200250	BPEP-200838
MAZDA	MAZDA3	2020	BPFP-108987	BPFP-116418
MAZDA	MAZDA3	2021	BPFP-116419	BPFP-201085
MAZDA	MAZDA3	2022	BPFP-201086	BPFP-204448
MAZDA	MX-30	2023	DR8V3P-100007	DR8V3P-101037
MAZDA	MX-30	2020	DREJ3P-100021	DREJ3P-103390
MAZDA	MX-30	2021	DREJ3P-103391	DREJ3P-107368
MAZDA	MX-30	2022	DREJ3P-107369	DREJ3P-150460
MAZDA	MX-30	2023	DREJ3P-150461	DREJ3P-151457
MAZDA	MX-30	2021	DRH3P-100065	DRH3P-100203
MAZDA	ROADSTER	2025	ND5RE-150119	ND5RE-158050
MAZDA	ROADSTER	2025	NDERE-200006	NDERE-200259
MAZDA	ROADSTER	2020	ND5RC-500614	ND5RC-600813
MAZDA	ROADSTER	2021	ND5RC-600814	ND5RC-604326
MAZDA	ROADSTER	2022	ND5RC-700004	ND5RC-700665
MAZDA	ROADSTER	2023	ND5RC-700666	ND5RC-704834
MAZDA	ROADSTER	2020	NDERC-500387	NDERC-600334
MAZDA	ROADSTER	2021	NDERC-600335	NDERC-601840
MAZDA	ROADSTER	2022	NDERC-700001	NDERC-700216
MAZDA	ROADSTER	2023	NDERC-700217	NDERC-701573
MAZDA	SCRUM	2020	DG17V-422614	DG17V-427575
MAZDA	SCRUM	2021	DG17V-427576	DG17V-430267
MAZDA	SCRUM	2022	DG17V-610001	DG17V-613440
MAZDA	SCRUM	2023	DG17V-613441	DG17V-618684
MAZDA	SCRUM	2024	DG17V-618685	DG17V-891179
MAZDA	SCRUM	2025	DG17V-891180	DG17V-895633
MAZDA	SCRUM	2020	DG17W-200578	DG17W-250920
MAZDA	SCRUM	2021	DG17W-250921	DG17W-280494
MAZDA	SCRUM	2022	DG17W-280495	DG17W-301002
MAZDA	SCRUM	2023	DG17W-301003	DG17W-302230
MAZDA	SCRUM	2024	DG17W-302231	DG17W-341938
MAZDA	SCRUM	2025	DG17W-341939	DG17W-343115
MAZDA	SCRUM TRUCK	2020	DG16T-520873	DG16T-523067
MAZDA	SCRUM TRUCK	2021	DG16T-523068	DG16T-640700
MAZDA	SCRUM TRUCK	2022	DG16T-640701	DG16T-691536
MAZDA	SCRUM TRUCK	2023	DG16T-691537	DG16T-693566
MAZDA	SCRUM TRUCK	2024	DG16T-693567	DG16T-821289
MAZDA	SCRUM TRUCK	2025	DG16T-821290	DG16T-823054
MAZDA	TITAN	2023	LKR88-7000631	LKR88-7000762
MAZDA	TITAN	2021	LPR88-7000148	LPR88-7000239
MAZDA	TITAN	2022	LPR88-7000240	LPR88-7000337
MAZDA	TITAN	2023	LPR88-7000338	LPR88-7000421
MAZDA	TITAN	2020	LKR88-7000117	LKR88-7000306
MAZDA	TITAN	2021	LKR88-7000307	LKR88-7000465
MAZDA	TITAN	2022	LKR88-7000466	LKR88-7000630`;

  var existing = {};
  window.AUM_YOM_DATABASE.forEach(function(r){
    existing[[r.make, r.name, r.year, r.start, r.end].join('|')] = true;
  });

  rows.trim().split(/\n/).forEach(function(line){
    var p = line.trim().split(/\t+|\s{2,}/).filter(Boolean);
    if (p.length < 5) return;
    var make = p[0].trim().toUpperCase();
    var name = p[1].trim().toUpperCase().replace(/\s+/g, ' ');
    var year = parseInt(p[2], 10);
    var start = p[3].trim().toUpperCase();
    var end = p[4].trim().toUpperCase();
    var chassis = start.split('-')[0];
    var endChassis = end.split('-')[0];
    var frameFrom = parseInt(start.split('-')[1], 10);
    var frameTo = parseInt(end.split('-')[1], 10);
    var key = [make, name, year, start, end].join('|');
    if (make !== 'MAZDA' || chassis !== endChassis || isNaN(year) || isNaN(frameFrom) || isNaN(frameTo) || frameTo < frameFrom || existing[key]) return;
    existing[key] = true;
    window.AUM_YOM_DATABASE.push({ make: make, name: name, chassis: chassis, start: start, end: end, frameFrom: frameFrom, frameTo: frameTo, year: year });
  });
})();

/* Mazda images: 21. Mazda rows added: 226. Exact duplicates skipped: 1. Invalid rows skipped: 0. */